import React, { useState } from 'react';
import { IKImage } from 'imagekitio-react';
import './Gallery.css';
import { useTranslation } from 'react-i18next';
import RoomCarousel from '../../components/RoomsCarousel/RoomsCarousel';

const imagePaths = [
    'destinations/olympus-about.jpg?updatedAt=1747054904122',
    'Sevasti-view/tree3.jpg',
    'Sevasti-view/043.JPG',
    'contact/eksw.jpg',

    'Sevasti-title/homeImage3.jpg',
    'Sevasti-title/homeImage2.jpg',
    'Sevasti-title/homeImage1.jpg',
    'Sevasti-title/homeImage4.jpg',
    'Sevasti-title/homeImage5.jpg',
    'Sevasti-Rooms/room1/039.JPG',
    'Sevasti-Rooms/room1/016.JPG',
    'Sevasti-Rooms/room1/015.JPG',
    'Sevasti-Rooms/room1/014.JPG',
    'Sevasti-Rooms/room1/017.JPG',
    'Sevasti-Rooms/room1/018.JPG',
    'Sevasti-Rooms/room1/019.JPG',
    'Sevasti-Rooms/room1/020.JPG',
    'Sevasti-Rooms/room1/INSIDE SMALL 2.jpg',
    'gallery/ekso (1).jpg',
    'gallery/ekso (2).jpg',
    'gallery/ekso (3).jpg',
    'gallery/ekso (4).jpg',
    'gallery/ekso (5).jpg',
    'gallery/ekso (6).jpg',
    'gallery/ekso (7).jpg',
    'gallery/ekso (8).jpg',
    'gallery/ekso (9).jpg',
    'gallery/ekso (10).jpg',
    'gallery/ekso (11).jpg',
    'gallery/ekso (12).jpg',
    'gallery/ekso (13).jpg',
    'gallery/ekso (14).jpg',
    'gallery/ekso (15).jpg',
    'gallery/ekso (16).jpg',
    'gallery/ekso (17).jpg',
    'gallery/ekso (18).jpg',
    'gallery/ekso (19).jpg',
    'gallery/ekso (20).jpg',
    'gallery/ekso (21).jpg',
    'gallery/ekso (22).jpg',
    'gallery/ekso (23).jpg',
    'gallery/ekso (24).jpg',
    'gallery/ekso (25).jpg',
    'gallery/ekso (26).jpg',
    'gallery/ekso (27).jpg',
    'gallery/ekso (28).jpg',
    'gallery/ekso (29).jpg',
    'gallery/ekso (30).jpg',
    'gallery/ekso (31).jpg',
    'gallery/ekso (32).jpg',
    'gallery/ekso (33).jpg',
    'gallery/ekso (34).jpg',
    'gallery/ekso (35).jpg',
    'gallery/ekso (36).jpg',
    'gallery/ekso (37).jpg',
    'gallery/ekso (38).jpg',
    'gallery/ekso (39).jpg',
    'gallery/ekso (40).jpg',
    'gallery/ekso (41).jpg',
    'gallery/ekso (42).jpg',
    'gallery/ekso (43).jpg',
    'gallery/ekso (44).jpg',
    'gallery/ekso (45).jpg',
    'gallery/ekso (46).jpg',
    'gallery/ekso (47).jpg',
];

// Deliberate span pattern: wide cells every ~5 items, tall cells at specific offsets.
// Pattern repeats every 27 images to distribute nicely across 5 columns.
const spanWide = new Set([0, 5, 11, 17, 23]);
const spanTall = new Set([2, 8, 14, 20, 26]);

const getSpanClass = (index: number): string => {
    const pos = index % 27;
    if (spanWide.has(pos)) return 'span-2';
    if (spanTall.has(pos)) return 'span-row-2';
    return '';
};

const Gallery = () => {
    const urlEndpoint = "https://ik.imagekit.io/kimchel";
    const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    return (
        <div className="gallery">
            <div className="gallery-container">
                <div className="gallery-header">
                    <h1>{t('gallery.title')}</h1>
                </div>
                <div className="gallery-grid">
                    {imagePaths.map((path, index) => (
                        <div
                            key={index}
                            className={`gallery-item ${getSpanClass(index)}`}
                            onClick={() => setActiveIndex(index)}
                            style={{ cursor: 'pointer' }}
                        >
                            <IKImage
                                urlEndpoint={urlEndpoint}
                                path={path}
                                transformation={[{ height: '300', width: '400', crop: 'maintain_ratio', format: 'auto' } as any]}
                                className="gallery-img"
                                loading="lazy"
                                alt=""
                            />
                        </div>
                    ))}
                </div>
            </div>

            {activeIndex !== null && (
                <RoomCarousel
                    images={imagePaths}
                    initialIndex={activeIndex}
                    onClose={() => setActiveIndex(null)}
                />
            )}
        </div>
    );
};

export default Gallery;
